/**
 * Created by comoon on 1/27/16.
 */

var keyMirror = require("keymirror");


var ActionConstants = keyMirror({

    /**
     * 初始化Tip信息
     */
    INIT_TRIP_INFO: null,

    /**
     * 提交报价申请
     */
    COMMIT_APPLY: null,

    /**
     * 下单
     */
    ORDER: null,

    /**
     * 切换报价记录
     */
    SWITCH_QUOTE_RECORD: null,

    /**
     * 刷新报价结果列表
     */
    FRESH_QUOTE_RESULT_LIST: null,

    /**
     * 二级口岸城市
     */
    SEARCH_PORT_INFO: null,
    /**
     * 通知当报价失效
     */
    ALERT_QUOTE_BECOME_INVALID: null,

    /**
     * 调整
     */
    TWEAK_QUOTE: null,
    /**
     * 报价完成,达人发给用户
     */
    SEND_TRIP_USER: null,
    /**
     * 切换品质类型
     */
    SWITCH_GRADE_TYPE: null,

    /**
     * 选择出发日期
     */
    SELECTED_CALEANDAR_STARTDATE: null,
    /**
     * 日历选择出发日期,二次确认
     */
    SELECTED_CALEANDAR_STARTDATE_CONFIRM: null,

    /**以下为列表页Action*/
    /**
     * 地区数据
     * 洲,国家,分线,城市景点,亮点,主题,天数
     */
    INIT_LOCATION_DATA: null,
    /**
     * 查询列表
     */
    SEARCH_POWER_LIST: null,
    /**
     * 滚动加载
     */
    LOAD_POWER_LIST: null,
    /**
     * 第一页数据
     */
    FIRST_POWER_LIST_DATA: null,
    /**
     * 更新报价列表的 new
     */
    QUOTE_LIST_UPDATE_NEW: null,

    /**
     * 点击询价列表 loading 层
     */
    LOADING_LAYER_SHOW: null,

    /**
     * 添加一条通知
     */
    ADD_NOTIFY:null,

    /**
     * 推荐标识,后台需要
     */
    WALLE_HAS_START_FLAG: null

});

var EventConstants = keyMirror({
    CHANGE: null,

    LOADING_LAYER: null,

    ACTION_SWITCH_QUOTE_RECORD_COMPLETE: null,

    ACTION_TWEAK_QUOTE_START: null,

    AJAX_COMMIT_APPLY_START: null,
    AJAX_COMMIT_APPLY_COMPLETE: null,

    AJAX_LOAD_PRODUCT_LIST_START: null,
    AJAX_LOAD_PRODUCT_LIST_COMPLETE: null,

    AJAX_RETRIEVE_RECORD_LIST_START: null,
    AJAX_RETRIEVE_RECORD_LIST_COMPLETE: null,

    AJAX_ORDER_COMPLETE: null,

    AJAX_SEND_TRIP_USER_COMPLETE: null,

    ACTION_SWITCH_GRADE_TYPE: null,
    /**
     * 价格和包含列表 loading
     */
    PRODUCT_LIST_LOADING: null,
    /**
     * 切换开始日期
     */
    START_DATE_CHANGE:null,
    /**
     * 添加通知
     */
    ADD_NOTIFY: null,

    //日历选择
    ACTION_SELECTED_CALEANDAR_STARTDATE: null,
    //日历选择后调用确认confirm
    ACTION_SELECTED_CALEANDAR_STARTDATE_CONFIRM: null,
    //二级口岸查询
    AJAX_SEARCH_PORT_INFO_COMPLETE: null,
    //列表页
    AJAX_SEARCH_POWER_LIST_COMPLETE: null,
    AJAX_LOAD_POWER_LIST_COMPLETE: null,
    ACTION_WALLE_HAS_START_FLAG: null
});

var FormatConstants = keyMirror({});

var ElementConstants = {
    TOP_NAV_CLASS: '.js-follow-nav'
};

module.exports = {
    ActionConstants,
    ElementConstants,
    EventConstants,
    FormatConstants
};


/** WEBPACK FOOTER **
 ** ./script/Constants.js
 **/